import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Trash2 } from "lucide-react";
import { api, fmtDate } from "../../lib/api";

export default function SubscribersTab() {
  const [items, setItems] = useState(null);

  const load = () => api("/admin/newsletter").then(setItems).catch((e) => toast.error(e.message));
  useEffect(() => { load(); }, []);

  const remove = async (id) => {
    if (!window.confirm("Remove this subscriber?")) return;
    try {
      await api(`/admin/newsletter/${id}`, { method: "DELETE" });
      toast.success("Subscriber removed");
      load();
    } catch (e) {
      toast.error(e.message);
    }
  };

  return (
    <div data-testid="subscribers-tab">
      <h2 className="font-display uppercase text-3xl text-ink">Subscribers</h2>
      <p className="mt-2 text-sm text-neutral-500">Readers signed up for The Weekly Edit.</p>

      <div className="mt-8 divide-y divide-gold/15 border-y border-gold/15">
        {!items ? (
          <p className="py-6 font-elegant italic text-xl text-gold">Loading</p>
        ) : items.length === 0 ? (
          <p className="py-6 text-sm text-neutral-500" data-testid="subscribers-empty">No subscribers yet.</p>
        ) : (
          items.map((s) => (
            <div key={s.id} data-testid={`subscriber-row-${s.id}`} className="py-4 flex items-center gap-5">
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium text-ink truncate">{s.email}</p>
                <p className="text-[10px] font-bold uppercase tracking-[0.2em] text-ink/40 mt-1">Joined {fmtDate(s.created_at)}</p>
              </div>
              <button onClick={() => remove(s.id)} data-testid={`subscriber-delete-${s.id}`} aria-label="Remove"
                className="w-10 h-10 shrink-0 border-2 border-ink/10 rounded-full flex items-center justify-center text-ink/50 hover:border-red-400 hover:text-red-500 transition-colors duration-300">
                <Trash2 size={15} />
              </button>
            </div>
          ))
        )}
      </div>
    </div>
  );
}
